<template>
  <table aria-labelledby="table-heading-pqs">
		<caption id="table-heading-pqs">Parent Quality Survey Ratings 2017 - 2018</caption>
		<thead>
			<tr>
				<th>Grade</th>
				<th>{{ s1Name }}</th>
				<th>{{ s2Name }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>'A' plus</td>
				<td v-for="(index, data) in s1Data.parentQsData" :key="index">{{ s1Data.isNull ? NA : data.aplus + ' %'}}</td>
        <td v-for="(index, data) in s2Data.parentQsData" :key="index">{{ s2Data.isNull ? NA : data.aplus + ' %'}}</td>
			</tr>
			<tr>
				<td>'A'</td>
        <td v-for="(index, data) in s1Data.parentQsData" :key="index">{{ s1Data.isNull ? NA : data.a + ' %'}}</td>
        <td v-for="(index, data) in s2Data.parentQsData" :key="index">{{ s2Data.isNull ? NA : data.a + ' %'}}</td>
			</tr>
			<tr>
				<td>'B'</td>
				<td v-for="(index, data) in s1Data.parentQsData" :key="index">{{ s1Data.isNull ? NA : data.b + ' %'}}</td>
        <td v-for="(index, data) in s2Data.parentQsData" :key="index">{{ s2Data.isNull ? NA : data.b + ' %'}}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['s1Name', 's2Name', 's1Data', 's2Data'],
		data() {
			return {
				NA: 'data point unavailable'
			}
		}
	}
</script>
